import declare from "dojo/_base/declare";
import HomePageUtil from "./util";
import NewItemPaneForm from "./NewItemPaneForm";

const NewProjectPaneForm = declare(NewItemPaneForm, {
	// Boolean: write hidden fields
	bWriteVisible: false,

	allowedPaneIds: [
		"HomeProjects",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [HomePageUtil.PROJECT_CONTEXT];
	},

	/**
	 * @override
	 * Set DashboardPane field disabled.
	 */
	_updateFieldVisibility: function(field) {
		if (this.allowedPaneIds.length === 1) {
			this.setFieldValue("DashboardPane", this.allowedPaneIds[0]);
			this.setFieldHidden("DashboardPane", true);
		}
	},
});

export = NewProjectPaneForm;